export default "__VITE_ASSET__f490683a__"